import React from "react"
import * as css from "./PastEventsSection.module.css"
import Overflow from "components/Layout/Overflow"
import Section from "components/Layout/Section"
import EventsList from "components/pages/events/EventsList"

function PastEventsSection({ events }) {
  return (
    <Section className={css.root} noPadding>
      <Overflow>
        <div className={css.divider} />
        <div className={css.label}>Past Events</div>
        <EventsList events={events} isPast />
      </Overflow>
    </Section>
  )
}

export default PastEventsSection
